export default __webpack_public_path__ + "locales/pl/Common.json?hash=66432e25dbe792b9a480c92842568027";